import { jsx as _jsx } from "react/jsx-runtime";
import { Modal } from "@/components/common";
import styles from "./PortalVideoModal.module.css";
export const PortalVideoModal = ({ isOpen, onClose, embedUrl }) => {
    return (_jsx(Modal, { isOpen: isOpen, onClose: onClose, title: "How to use the portal", children: _jsx("div", { className: styles.videoWrapper, children: _jsx("iframe", { src: embedUrl, loading: "lazy", title: "Synthesia video player - How to navigate the TDG client portal", allow: "encrypted-media; fullscreen; microphone; screen-wake-lock;", allowFullScreen: true }) }) }));
};
